import { getEdlDuration } from "./projectSchema";

export const selectVideoEditorEdl = (state) => state?.videoEditor?.edl || null;

export const selectVideoEditorPlayhead = (state) =>
  state?.videoEditor?.edl?.playhead || 0;

export const selectVideoEditorTracksOrdered = (state) => {
  const edl = selectVideoEditorEdl(state);
  if (!edl) return [];
  return (edl.tracks?.order || [])
    .map((trackId) => edl.tracks?.byId?.[trackId])
    .filter(Boolean);
};

export const selectVideoEditorClipsForTrack = ({ state, trackId }) => {
  const edl = selectVideoEditorEdl(state);
  const track = edl?.tracks?.byId?.[trackId];
  if (!track) return [];
  return (track.clipIds || [])
    .map((clipId) => edl.clips?.byId?.[clipId])
    .filter(Boolean);
};

export const selectVideoEditorAllClips = (state) => {
  const edl = selectVideoEditorEdl(state);
  return Object.values(edl?.clips?.byId || {});
};

export const selectVideoEditorDuration = (state) => {
  const edl = selectVideoEditorEdl(state);
  if (!edl) return 0;
  return getEdlDuration({ edl });
};

export const selectVideoEditorCompositionSize = (state) => {
  const edl = selectVideoEditorEdl(state);
  return {
    width: edl?.compositionWidth || 1080,
    height: edl?.compositionHeight || 1920,
  };
};

export const selectVideoEditorIsDirty = (state) =>
  Boolean(state?.videoEditor?.isDirty);

export const selectVideoEditorIsExporting = (state) =>
  Boolean(state?.videoEditor?.isExporting);

export const selectVideoEditorSelectedClipId = (state) =>
  state?.videoEditor?.selectedClipId ||
  state?.videoEditor?.selectedClipIds?.[state.videoEditor.selectedClipIds.length - 1] ||
  null;

export const selectVideoEditorSelectedClipIds = (state) =>
  state?.videoEditor?.selectedClipIds ||
  (state?.videoEditor?.selectedClipId ? [state.videoEditor.selectedClipId] : []);

export const selectVideoEditorSelectedClips = (state) => {
  const edl = selectVideoEditorEdl(state);
  return selectVideoEditorSelectedClipIds(state)
    .map((clipId) => edl?.clips?.byId?.[clipId])
    .filter(Boolean);
};

export const selectVideoEditorPrimaryClip = (state) => {
  const edl = selectVideoEditorEdl(state);
  const clipId = selectVideoEditorSelectedClipId(state);
  return edl?.clips?.byId?.[clipId] || null;
};
